import { getFeatureLayer, getImageLayer, getLayerByLayerId } from "../../utils/layer/Layers";
export async function createLayer(layer, type) {
    let layerItem;
    switch (type) {
        case type = 'featureLayer':
            layerItem = await getFeatureLayer(layer);
            return layerItem;
        case type = 'ImageLayer':
            layerItem = await getImageLayer(layer);
            return layerItem;
        default:
            console.log('type allowed is featureLayer or ImageLayer');
            break;
    }
}
export function getLayerById(mapView, id) {
    return getLayerByLayerId(mapView, id);
}
